import MaskClientCheck from 'assets/secure-financing/mask-client-check.inline.svg';
import React from 'react';

export default function ClientContainer({ title, children, ...props }) {
	return (
		<div tw='relative flex-1 h-min bg-grey-blue-F rounded-10' {...props}>
			<div className='w-full h-24 flex items-center justify-center'>
				<div className='absolute top-0 w-full text-center'>
					<p style={{ transform: 'translate(0px,-10px)' }} className='relative z-10 text-11 font-bold text-green-1'>
						{title}
					</p>
					<div style={{ transform: 'translate(0px,0px)' }} className="absolute bottom-0 w-full flex items-center justify-center"><MaskClientCheck/></div>
				</div>
			</div>
			{children}
		</div>
	);
}
